(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["default_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ===== CLEOGENE CUSTOM - Wishlist by Square Integration ===== */
  document.addEventListener('DOMContentLoaded', function() {
    // Function to find and move wishlist icon
    function findAndMoveWishlistIcon() {
      console.log('Looking for wishlist icon...');
      
      // Try multiple selectors for wishlist icon, prioritizing Vtl-WishlistHeaderWrapper
      const wishlistSelectors = [
        '.Vtl-WishlistHeaderWrapper', // Primary target from DevTools
        '[data-wishlist-icon]',
        '.wishlist-icon',
        '#wishlist-icon',
        '.wishlist-button',
        '[data-wishlist-button]',
        '.header__icon[href*="wishlist"]',
        '.header__icon[href*="favorites"]',
        '.header__icon[href*="heart"]',
        '.header__icon svg[viewBox*="24"]', // Generic heart icon
        '.header__icons .header__icon:has(svg[viewBox*="24"])' // Heart icon in header
      ];
      
      let wishlistIcon = null;
      for (let selector of wishlistSelectors) {
        wishlistIcon = document.querySelector(selector);
        console.log('Trying selector:', selector, 'Found:', wishlistIcon);
        if (wishlistIcon && wishlistIcon.closest('.header__icons')) {
          console.log('Found wishlist icon in header__icons:', wishlistIcon);
          break;
        }
      }
      
      if (wishlistIcon) {
        // Move the wishlist icon to our custom container
        const customContainer = document.getElementById('wishlist-header-icon');
        const wishlistLink = document.getElementById('wishlist-link');
        console.log('Custom container found:', customContainer);
        
        if (customContainer && wishlistIcon && wishlistLink) {
          // Get the original URL from the wishlist icon
          const originalUrl = wishlistIcon.href || wishlistIcon.getAttribute('href') || '#';
          wishlistLink.href = originalUrl;
          
          // Move the entire element instead of cloning
          customContainer.appendChild(wishlistIcon);
          console.log('Moved wishlist icon to custom container and set link URL:', originalUrl);
          
          return true; // Success
        }
      }
      return false; // Not found
    }

    // Wait for Wishlist by Square plugin to load
    const checkWishlistPlugin = setInterval(function() {
      if (findAndMoveWishlistIcon()) {
        clearInterval(checkWishlistPlugin);
      }
    }, 100);

    // Stop checking after 5 seconds
    setTimeout(function() {
      clearInterval(checkWishlistPlugin);
    }, 5000);

    // Also try on window load in case DOMContentLoaded was too early
    window.addEventListener('load', function() {
      setTimeout(findAndMoveWishlistIcon, 1000);
    });

    // Try with MutationObserver to catch dynamically added elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('Vtl-WishlistHeaderWrapper')) {
              console.log('Vtl-WishlistHeaderWrapper detected via MutationObserver');
              setTimeout(findAndMoveWishlistIcon, 100);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ===== CLEOGENE CUSTOM - Transparent Header JavaScript ===== */
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header[data-transparent="true"]');
    
    if (!header) return;
    
    
    let isScrolled = false;
    let isHovered = false;
    let isDrawerOpen = false;
    
    
    // Scroll detection
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      isScrolled = scrollTop > 50;
      updateHeaderStateWithDrawerPriority();
    }
    
    // Hover detection
    header.addEventListener('mouseenter', () => {
      isHovered = true;
      updateHeaderStateWithDrawerPriority();
    });
    
    header.addEventListener('mouseleave', () => {
      isHovered = false;
      updateHeaderStateWithDrawerPriority();
    });
    
    // Drawer menu detection - try multiple approaches
    const drawerSelectors = [
      'header-drawer',
      '.header-drawer',
      '[data-drawer]',
      '.menu-drawer',
      '.drawer',
      'details[open]',
      'details'
    ];
    
    let menuDrawer = null;
    for (let selector of drawerSelectors) {
      menuDrawer = header.querySelector(selector) || document.querySelector(selector);
      if (menuDrawer) break;
    }
    
    if (menuDrawer) {
      // Try different event names
      const events = ['open', 'opened', 'show', 'shown', 'toggle', 'click'];
      events.forEach(eventName => {
        menuDrawer.addEventListener(eventName, () => {
          isDrawerOpen = true;
          updateHeaderStateWithDrawerPriority();
        });
      });
      
      const closeEvents = ['close', 'closed', 'hide', 'hidden'];
      closeEvents.forEach(eventName => {
        menuDrawer.addEventListener(eventName, () => {
          isDrawerOpen = false;
          updateHeaderStateWithDrawerPriority();
        });
      });
      
      // Also try to detect by class changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const hasOpenClass = menuDrawer.classList.contains('open') || 
                                menuDrawer.classList.contains('opened') ||
                                menuDrawer.classList.contains('active');
            isDrawerOpen = hasOpenClass;
            updateHeaderStateWithDrawerPriority();
          }
        });
      });
      observer.observe(menuDrawer, { attributes: true, attributeFilter: ['class'] });
      
      // Also check for details element open attribute
      if (menuDrawer.tagName === 'DETAILS') {
        const detailsObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              isDrawerOpen = menuDrawer.hasAttribute('open');
              updateHeaderStateWithDrawerPriority();
            }
          });
        });
        detailsObserver.observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
      }
    }
    
    // Force opaque state when drawer is open (ignore mouse events)
    function updateHeaderStateWithDrawerPriority() {
      if (isDrawerOpen) {
        // When drawer is open, always stay opaque regardless of scroll/hover
        header.setAttribute('data-opaque', 'true');
      } else {
        // Normal behavior when drawer is closed
        if (isScrolled || isHovered) {
          header.setAttribute('data-opaque', 'true');
        } else {
          header.removeAttribute('data-opaque');
        }
      }
    }
    
    
    // Initialize
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check initial state
  });

  /* ===== CLEOGENE CUSTOM - Wishlist by Square Integration ===== */
  document.addEventListener('DOMContentLoaded', function() {
    // Function to find and move wishlist icon
    function findAndMoveWishlistIcon() {
      console.log('Looking for wishlist icon...');
      
      // Try multiple selectors for wishlist icon, prioritizing Vtl-WishlistHeaderWrapper
      const wishlistSelectors = [
        '.Vtl-WishlistHeaderWrapper', // Primary target from DevTools
        '[data-wishlist-icon]',
        '.wishlist-icon',
        '#wishlist-icon',
        '.wishlist-button',
        '[data-wishlist-button]',
        '.header__icon[href*="wishlist"]',
        '.header__icon[href*="favorites"]',
        '.header__icon[href*="heart"]',
        '.header__icon svg[viewBox*="24"]', // Generic heart icon
        '.header__icons .header__icon:has(svg[viewBox*="24"])' // Heart icon in header
      ];
      
      let wishlistIcon = null;
      for (let selector of wishlistSelectors) {
        wishlistIcon = document.querySelector(selector);
        console.log('Trying selector:', selector, 'Found:', wishlistIcon);
        if (wishlistIcon && wishlistIcon.closest('.header__icons')) {
          console.log('Found wishlist icon in header__icons:', wishlistIcon);
          break;
        }
      }
      
      if (wishlistIcon) {
        // Move the wishlist icon to our custom container
        const customContainer = document.getElementById('wishlist-header-icon');
        const wishlistLink = document.getElementById('wishlist-link');
        console.log('Custom container found:', customContainer);
        
        if (customContainer && wishlistIcon && wishlistLink) {
          // Get the original URL from the wishlist icon, but prioritize the correct wishlist URL
          const originalUrl = wishlistIcon.href || wishlistIcon.getAttribute('href') || '#';
          // Force the correct wishlist URL
          const wishlistUrl = originalUrl.includes('/a/page/wishlist') ? originalUrl : '/a/page/wishlist';
          wishlistLink.href = wishlistUrl;
          
          // If the wishlist icon is a link, extract its content (SVG) instead of moving the entire link
          if (wishlistIcon.tagName === 'A') {
            // Clone the content of the link (SVG icon) instead of the link itself
            const iconContent = wishlistIcon.innerHTML;
            customContainer.innerHTML = iconContent;
            console.log('Extracted wishlist icon content and set link URL:', originalUrl);
          } else {
            // If it's not a link, move it directly
            customContainer.appendChild(wishlistIcon);
            console.log('Moved wishlist icon to custom container and set link URL:', originalUrl);
          }
          
          return true; // Success
        }
      }
      return false; // Not found
    }

    // Wait for Wishlist by Square plugin to load
    const checkWishlistPlugin = setInterval(function() {
      if (findAndMoveWishlistIcon()) {
        clearInterval(checkWishlistPlugin);
      }
    }, 100);

    // Stop checking after 5 seconds
    setTimeout(function() {
      clearInterval(checkWishlistPlugin);
      // Ensure the wishlist link has the correct URL even if icon wasn't found
      const wishlistLink = document.getElementById('wishlist-link');
      if (wishlistLink && !wishlistLink.href.includes('/a/page/wishlist')) {
        wishlistLink.href = '/a/page/wishlist';
        console.log('Set fallback wishlist URL:', wishlistLink.href);
      }
    }, 5000);

    // Also try on window load in case DOMContentLoaded was too early
    window.addEventListener('load', function() {
      setTimeout(findAndMoveWishlistIcon, 1000);
    });

    // Try with MutationObserver to catch dynamically added elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('Vtl-WishlistHeaderWrapper')) {
              console.log('Vtl-WishlistHeaderWrapper detected via MutationObserver');
              setTimeout(findAndMoveWishlistIcon, 100);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
